import { render, staticRenderFns } from "./SchoolStudentInfo.vue?vue&type=template&id=07c5ca30&scoped=true&"
import script from "./SchoolStudentInfo.vue?vue&type=script&lang=js&"
export * from "./SchoolStudentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c5ca30",
  null
  
)

export default component.exports